import axios from 'axios';
import { sendLiveCustomLog } from '@/utils/kibtLogger';


const request = axios.create({
    timeout: 30 * 1000,
});

request.interceptors.response.use(
    async response => {
        if (response.status === 200) {
            if (response.data && response.data.eventsCode === 101) {
                sendLiveCustomLog({
                    name: 'midyear-api-101',
                    extra_info: JSON.stringify({
                        response: JSON.stringify(response.data),
                        request_url: response.request?._url,
                    }),
                });
                setTimeout(() => {
                    window.location.replace('/events/end');
                }, 100);
                return;
            }
            return Promise.resolve(response.data);
        }
        return Promise.reject(response);
    },
    error => {
        sendLiveCustomLog({
            name: 'midyear-api-network-error',
        });
        console.error(error);
        return Promise.reject(error);
    }
);

export default request;
